
jQuery(document).ready(function($) {

    const groupEditor = $('#users-editor');
    if (groupEditor.length) {

        let multiEdit = $('#multiedit');

        groupEditor.on('click', 'input.user-check', function(){
            let selected = groupEditor.find('input.user-check:checked');
            let selectedUser = selected.map(function(){ return this.value; }).get();
            if (selectedUser.length > 0) {
                multiEdit.find('.selected_users').val(selectedUser.join(','));
                multiEdit.show();
            } else {
                multiEdit.find('.selected_users').val('');
                multiEdit.hide();
            }
        });

        $('#user-filter select').on('change', function (e) {
            $(this).parents('form').submit();
        });

        $('#user-filter input[type="search"]').on('input', function (e) {
            if (!e.currentTarget.value && !e.inputType) {
                $(this).parents('form').submit();
            }
        });
    }


});
